import { useCallback, useRef, useState } from 'react';

// Creates a ref that can be used as usual but also adds
// a way to cause a re-render through a useState hook that will
// also update the ref current value.
const useRefState = initialState => {
  const [state, setState] = useState(initialState);
  const ref = useRef(state);

  // in case initialState is a function, we need to update
  // the ref as well
  ref.current = state;

  const updateState = useCallback(newState => {
    if (typeof newState === 'function') {
      setState(previous => {
        const updated = newState(previous);

        ref.current = updated;

        return updated;
      });

      return;
    }

    ref.current = newState;
    setState(newState);
  }, []);

  return [ref, updateState];
};

export default useRefState;
